module.exports = ".ssf-showHide {\n  font-size: 0.7rem;\n  cursor: pointer !important; }\n  .ssf-showHide:hover {\n    font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/details-button/details-button.component.scss
// module id = 619
// module chunks = 3